/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

const filter = 'grayscale(50%) brightness(70%)';

type SelectedProps = {
  selected: boolean;
};

type ColorProps = {
  color: string;
};

type CommonProps = SelectedProps & ColorProps;

export const Root = styled(Box)(() => ({
  flexShrink: 0,
  position: 'relative',
  height: '78px',
}));

export const Background = styled(Box, {
  shouldForwardProp: prop => prop !== 'color' && prop !== 'selected',
})<CommonProps>(({theme, color, selected}) => ({
  width: '100%',
  height: '100%',
  background: color,
  opacity: 0.2,
  position: 'absolute',
  top: '0',
  left: '0',
  zIndex: 0,
  borderRadius: theme.spacing(2),
  filter: selected ? 'none' : filter,
}));

export const Content = styled(Box)(({theme}) => ({
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const HeadingRow = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  minHeight: '26px',
}));

export const IconAndNameBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'selected',
})<SelectedProps>(({theme, selected}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  filter: selected ? 'none' : filter,
}));

export const IconBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  userSelect: 'none',
}));

export const IconText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'color',
})<ColorProps>(({color}) => ({
  color: color,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '14px',
  letterSpacing: 0.12,
}));

export const WidgetNameText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'color',
})<ColorProps>(({color}) => ({
  color: color,
  fontSize: '20px',
  lineHeight: '24px',
}));

export const StatsBox = styled(Box)(() => ({
  display: 'flex',
}));

type DividerProps = {
  hideLine?: boolean;
} & ColorProps;

export const StatsDivider = styled(Box, {
  shouldForwardProp: prop => prop !== 'color' && prop !== 'hideLine',
})<DividerProps>(({theme, color, hideLine}) => ({
  width: '1px',
  height: '32px',
  background: hideLine ? 'transparent' : color,
  margin: theme.spacing(0, hideLine ? 1 : 2),
  flexShrink: 0,
  opacity: 0.2,
}));

interface BodyRowProps {
  showRightColumnOnly: boolean;
  selected: boolean;
}

export const BodyRow = styled(Box, {
  shouldForwardProp: prop => prop !== 'showRightColumnOnly' && prop !== 'selected',
})<BodyRowProps>(({theme, showRightColumnOnly, selected}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: showRightColumnOnly ? 'flex-end' : 'space-between',
  filter: selected ? 'none' : filter,
}));

export const ValueBox = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

export const ColumnValueText = styled(Typography)(() => ({
  color: '#FFF',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const ButtonsWrap = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));
